module.exports = __webpack_public_path__ + "831f49ff6.jpg";